import { LoadableLazy } from '@confluence/loadable';

export const SaveCompanyHubConfirmationModalLoadable = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SaveCompanyHubConfirmationModal" */ './SaveCompanyHubConfirmationModal'
			)
		).SaveCompanyHubConfirmationModal,
});
